;(function (Wishlist, $) {
    var $wishlistBtn = $('.wishremove');
    var $wishlistCart = $('.cart');
    var $wishcount = $('.wishcount');
    var numProductTiles = $wishlistCart.length;
    var wishlist = localStorage.getItem('wishtems') || [];
    var wishcountall = localStorage.getItem('wishtemscount');

    $wishcount.html(wishcountall == null ? 0 : wishcountall);

    if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem('wishtems'));
    }
    var animateWishlist = function (e) {
        $(e).toggleClass('wishactive');
    };
    var updateWishlist = function (self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        //var wishcountvalue = localStorage.getItem('wishtemscount');
        if (isRemove) {
            var removeIndex = wishlist.indexOf(productHandle);
                wishlist.splice(removeIndex, 1);
            var wishcountp = localStorage.getItem('wishtemscount');
            if(wishcountp != null){
                var minus_val = -1;
                var wish_ct = Math.max(parseInt(wishcountp) + minus_val, 0);
                localStorage.setItem('wishtemscount', wish_ct);
            }
            localStorage.setItem('wishtems', JSON.stringify(wishlist));
            //var icon_length = $(self).find("span").length;
            if($(self).find("span").length != 0){
                $wishlistBtn.html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none"><path d="M8.00084 12.8426C7.92178 12.8426 7.8427 12.8275 7.76886 12.7967C7.52497 12.6945 1.78498 10.2472 0.864611 5.88871C0.508844 4.20252 0.866107 2.55746 1.82004 1.4891C2.59199 0.623718 3.70177 0.163586 5.03012 0.157415C5.03684 0.157415 5.04355 0.157415 5.04952 0.157415C6.56507 0.157415 7.48921 0.950816 8.00012 1.62625C8.51326 0.948074 9.44477 0.151243 10.97 0.157415C12.2991 0.163586 13.4097 0.623718 14.1824 1.4891C15.1348 2.55677 15.4913 4.20182 15.1348 5.88938C14.2159 10.2478 8.47517 12.6959 8.23128 12.7974C8.15893 12.8276 8.0799 12.8426 8.00084 12.8426ZM5.04879 1.18533C5.04431 1.18533 5.04061 1.18533 5.03613 1.18533C4.03819 1.18944 3.24761 1.51104 2.68525 2.14122C1.94015 2.97574 1.67089 4.30331 1.96326 5.69259C2.67554 9.06909 6.95144 11.2634 8.00084 11.7557C9.05025 11.2634 13.3262 9.06909 14.0377 5.69259C14.3316 4.30263 14.0623 2.97506 13.3187 2.14122C12.7564 1.51172 11.9657 1.1908 10.9656 1.186C10.9611 1.186 10.9566 1.186 10.9529 1.186C9.18376 1.186 8.55654 2.81598 8.53118 2.88524C8.45362 3.09301 8.24024 3.23425 8.00157 3.23425C8.00008 3.23425 7.99931 3.23425 7.99857 3.23425C7.75915 3.23357 7.54585 3.09301 7.46978 2.88386C7.44516 2.81529 6.81718 1.18533 5.04879 1.18533Z" fill="#4F4632"></path></svg></span>');
            }
            //var wishcountp_value = localStorage.getItem('wishtemscount');
            $wishcount.html(localStorage.getItem('wishtemscount'));
        }
        else {
            wishlist.push(productHandle);
            var wishcountp = localStorage.getItem('wishtemscount');
            if(wishcountp == null){
                var plus_val = 1;
                var wish_ct = plus_val;
            }else{
            var plus_val = 1;
            var wish_ct = Math.max(parseInt(wishcountp) + plus_val, 0);
        }
            localStorage.setItem('wishtemscount',wish_ct);
            localStorage.setItem('wishtems', JSON.stringify(wishlist));
            var icon_length = $(self).find("span").length;
            if(icon_length != 0){
                $wishlistBtn.html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none"><path d="M8.00084 12.8426C7.92178 12.8426 7.8427 12.8275 7.76886 12.7967C7.52497 12.6945 1.78498 10.2472 0.864611 5.88871C0.508844 4.20252 0.866107 2.55746 1.82004 1.4891C2.59199 0.623718 3.70177 0.163586 5.03012 0.157415C5.03684 0.157415 5.04355 0.157415 5.04952 0.157415C6.56507 0.157415 7.48921 0.950816 8.00012 1.62625C8.51326 0.948074 9.44477 0.151243 10.97 0.157415C12.2991 0.163586 13.4097 0.623718 14.1824 1.4891C15.1348 2.55677 15.4913 4.20182 15.1348 5.88938C14.2159 10.2478 8.47517 12.6959 8.23128 12.7974C8.15893 12.8276 8.0799 12.8426 8.00084 12.8426ZM5.04879 1.18533C5.04431 1.18533 5.04061 1.18533 5.03613 1.18533C4.03819 1.18944 3.24761 1.51104 2.68525 2.14122C1.94015 2.97574 1.67089 4.30331 1.96326 5.69259C2.67554 9.06909 6.95144 11.2634 8.00084 11.7557C9.05025 11.2634 13.3262 9.06909 14.0377 5.69259C14.3316 4.30263 14.0623 2.97506 13.3187 2.14122C12.7564 1.51172 11.9657 1.1908 10.9656 1.186C10.9611 1.186 10.9566 1.186 10.9529 1.186C9.18376 1.186 8.55654 2.81598 8.53118 2.88524C8.45362 3.09301 8.24024 3.23425 8.00157 3.23425C8.00008 3.23425 7.99931 3.23425 7.99857 3.23425C7.75915 3.23357 7.54585 3.09301 7.46978 2.88386C7.44516 2.81529 6.81718 1.18533 5.04879 1.18533Z" fill="#4F4632"></path></svg></span>');
            }
            var wishcountp_value = localStorage.getItem('wishtemscount');
            $wishcount.html(wishcountp_value);
        }
    };
    var activateWishItems = function () {
        $wishlistBtn.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) > -1) {
                $(this).addClass('wishactive');
                var icon_length = $(this).find("span").length;
                if($(this).hasClass('wishactive')){
                    if(icon_length != 0){
                        $(this).html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none"><path d="M8.00084 12.8426C7.92178 12.8426 7.8427 12.8275 7.76886 12.7967C7.52497 12.6945 1.78498 10.2472 0.864611 5.88871C0.508844 4.20252 0.866107 2.55746 1.82004 1.4891C2.59199 0.623718 3.70177 0.163586 5.03012 0.157415C5.03684 0.157415 5.04355 0.157415 5.04952 0.157415C6.56507 0.157415 7.48921 0.950816 8.00012 1.62625C8.51326 0.948074 9.44477 0.151243 10.97 0.157415C12.2991 0.163586 13.4097 0.623718 14.1824 1.4891C15.1348 2.55677 15.4913 4.20182 15.1348 5.88938C14.2159 10.2478 8.47517 12.6959 8.23128 12.7974C8.15893 12.8276 8.0799 12.8426 8.00084 12.8426ZM5.04879 1.18533C5.04431 1.18533 5.04061 1.18533 5.03613 1.18533C4.03819 1.18944 3.24761 1.51104 2.68525 2.14122C1.94015 2.97574 1.67089 4.30331 1.96326 5.69259C2.67554 9.06909 6.95144 11.2634 8.00084 11.7557C9.05025 11.2634 13.3262 9.06909 14.0377 5.69259C14.3316 4.30263 14.0623 2.97506 13.3187 2.14122C12.7564 1.51172 11.9657 1.1908 10.9656 1.186C10.9611 1.186 10.9566 1.186 10.9529 1.186C9.18376 1.186 8.55654 2.81598 8.53118 2.88524C8.45362 3.09301 8.24024 3.23425 8.00157 3.23425C8.00008 3.23425 7.99931 3.23425 7.99857 3.23425C7.75915 3.23357 7.54585 3.09301 7.46978 2.88386C7.44516 2.81529 6.81718 1.18533 5.04879 1.18533Z" fill="#4F4632"></path></svg></span>');
                    }
                }else{
                    if(icon_length != 0){
                        $(this).html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none"><path d="M8.00084 12.8426C7.92178 12.8426 7.8427 12.8275 7.76886 12.7967C7.52497 12.6945 1.78498 10.2472 0.864611 5.88871C0.508844 4.20252 0.866107 2.55746 1.82004 1.4891C2.59199 0.623718 3.70177 0.163586 5.03012 0.157415C5.03684 0.157415 5.04355 0.157415 5.04952 0.157415C6.56507 0.157415 7.48921 0.950816 8.00012 1.62625C8.51326 0.948074 9.44477 0.151243 10.97 0.157415C12.2991 0.163586 13.4097 0.623718 14.1824 1.4891C15.1348 2.55677 15.4913 4.20182 15.1348 5.88938C14.2159 10.2478 8.47517 12.6959 8.23128 12.7974C8.15893 12.8276 8.0799 12.8426 8.00084 12.8426ZM5.04879 1.18533C5.04431 1.18533 5.04061 1.18533 5.03613 1.18533C4.03819 1.18944 3.24761 1.51104 2.68525 2.14122C1.94015 2.97574 1.67089 4.30331 1.96326 5.69259C2.67554 9.06909 6.95144 11.2634 8.00084 11.7557C9.05025 11.2634 13.3262 9.06909 14.0377 5.69259C14.3316 4.30263 14.0623 2.97506 13.3187 2.14122C12.7564 1.51172 11.9657 1.1908 10.9656 1.186C10.9611 1.186 10.9566 1.186 10.9529 1.186C9.18376 1.186 8.55654 2.81598 8.53118 2.88524C8.45362 3.09301 8.24024 3.23425 8.00157 3.23425C8.00008 3.23425 7.99931 3.23425 7.99857 3.23425C7.75915 3.23357 7.54585 3.09301 7.46978 2.88386C7.44516 2.81529 6.81718 1.18533 5.04879 1.18533Z" fill="#4F4632"></path></svg></span>');
                    }
                }
            }
        });
    };
    var displayWishItems = function () {
        $wishlistCart.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) === -1) {
                $(this).remove();
                numProductTiles--;
            }
        });
    };
    var loadWishlist = function () {
        if (window.location.href.indexOf('pages/wishlist') > -1) {
        displayWishItems();
            $('.wishloader').fadeOut(2000, function () {
                $('.mainwish .wishlist-hero').addClass('wishvisible');
                //$('.wishlist-hero').addClass('wishvisible');
                if (numProductTiles == 0) {
                    $('.wishempty').addClass('wishvisible');
                    $('.mainwish').hide();
                } else {
                    $('.wishempty').hide();
                }
            });
        }
    };
    var bindUIActions = function () {
        $wishlistBtn.click(function (e) {
            e.preventDefault();
            updateWishlist(this);
            animateWishlist(this);
        });
    };
    Wishlist.init = function () {
        bindUIActions();
        activateWishItems();
        loadWishlist();
    };
    $("#wishcall").click(function(){
        //var raw = localStorage.getItem('wishtems');
        //var length = raw.length;
        var length = localStorage.getItem('wishtems').length;
        //var i;
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        for ( var i=length-1; i>= 0; i--){
        var removeIndex = wishlist.indexOf(productHandle);
        wishlist.splice(removeIndex, 1);
        var wishcountp = localStorage.getItem('wishtemscount');
            if(wishcountp != null){
                var wish_ct = Math.max(parseInt(0), 0);
                localStorage.setItem('wishtemscount', wish_ct);
            }
            localStorage.setItem('wishtems', JSON.stringify(wishlist));
        }
        location.reload(true);
    });
}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
function reloadPage(){
    location.reload(true);
}